import { render, staticRenderFns } from "./DealSet.vue?vue&type=template&id=2f23105a&scoped=true&"
import script from "./DealSet.vue?vue&type=script&lang=js&"
export * from "./DealSet.vue?vue&type=script&lang=js&"
import style0 from "./DealSet.vue?vue&type=style&index=0&id=2f23105a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23105a",
  null
  
)

export default component.exports